import { Component, AfterViewInit } from '@angular/core';
import { BaseElement } from '../base-element';
import { ShelfElement } from '../shelf-element';
import { ERASER } from '../eraser';

import { DataService } from '../data.service';
import { ShelfElementService } from '../shelf-element.service';

import * as THREE from 'three';


@Component({
  selector: 'app-shelf-elements',
  templateUrl: './shelf-elements.component.html',
  styleUrls: ['./shelf-elements.component.css']
})
export class ShelfElementsComponent implements AfterViewInit {

    activeElement: BaseElement;

    shelfElements: ShelfElement[];

    eraser: BaseElement;

    public currentStep: number;

    scene;

    constructor(private dataService: DataService, private shelfElementService: ShelfElementService) {
    }

    ngAfterViewInit() {
        this.getFloorShelfElements();
        this.getEraser();
        this.currentStep = this.dataService.getSharedData('currentStep');
        this.scene = this.dataService.getSharedData('scene');
        const self = this;
    }

    getEraser() {
      this.eraser = ERASER;
    }

    getShelfElements(): void {
        this.shelfElementService.getShelfElements().subscribe(shelfElements => this.shelfElements = shelfElements);
    }

    getFloorShelfElements(): void {
        this.shelfElementService.getFloorShelfElements().subscribe(shelfElements => this.shelfElements = shelfElements);
    }

    getNonFloorShelfElements(): void {
        this.shelfElementService.getNonFloorShelfElements().subscribe(shelfElements => this.shelfElements = shelfElements);
    }

    getStandardShelfElements(): void {
        this.shelfElementService.getStandardShelfElements().subscribe(shelfElements => this.shelfElements = shelfElements);
    }

    getTopShelfElements(): void {
        this.shelfElementService.getTopShelfElements().subscribe(shelfElements => this.shelfElements = shelfElements);
    }

    onSelect( selectedElement: BaseElement): void {
        this.activeElement = selectedElement;
        this.dataService.shareData('activeElement', selectedElement);
    }


    setShelfElementStyle(element) {
      return {
          'background-image': element.image
      };
    }

    initStandardShelfStep() {
        this.getStandardShelfElements();
        this.currentStep = 2;
        this.dataService.shareData('currentStep', this.currentStep);
        this.scene.prepareNextStep();
        this.scene.currentStep = 2;
    }

    initTopElementsStep() {
        this.getTopShelfElements();
        this.currentStep = 3;
        this.dataService.shareData('currentStep', this.currentStep);
        this.scene.currentStep = 3;
        this.scene.prepareNextStep();

    }

    backToStandardElements() {
        this.initStandardShelfStep();
    }

    backToFloorElements() {
        this.getFloorShelfElements();
        this.currentStep = 1;
        this.scene.currentStep = 1;
        this.dataService.shareData('currentStep', this.currentStep);
    }

    showElementList() {
        this.scene.showElementList();
    }


}



// WEBPACK FOOTER //
// ./src/app/shelf-elements/shelf-elements.component.ts